export const token = state => state.token;

export const backurl = state => state.backurl;

export const user = state => state.user;

export const wxUrl = state => state.wxUrl;

export const verifyCodeTime = state => state.verifyCodeTime;

export const isVerifyCodeReady = state => state.isVerifyCodeReady;

export const isStartClass = state => state.isStartClass;

export const isEndClass = state => state.isEndClass;

export const startClassRecordId = state => state.startClassRecordId;

export const loadingCount = state => state.loadingCount;



// WEBPACK FOOTER //
// ./src/store/getters.js